var InlineVariations, _scrollToBuyButton, _scrollToTouchInlineVariation;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Collections == null) {
  InlineVariations.Collections = {};
}

InlineVariations.Collections.Options = require('./collections/options');

InlineVariations.Collections.Traits = require('./collections/traits');

InlineVariations.Views.Main = require('./views/main');

_scrollToBuyButton = function() {
  if (!$('#purchase-cluster .buy.fixed, .header-row-sticked, .header-row-sticky').length) {
    return;
  }
  return $('body, html').animate({
    scrollTop: $('.main').position().top - 100
  }, 500);
};

_scrollToTouchInlineVariation = function() {
  var $inlineVariationContainer;
  $inlineVariationContainer = $('#inline-variations-container');
  if (!$inlineVariationContainer.length) {
    return;
  }
  return $('body, html').animate({
    scrollTop: $inlineVariationContainer.position().top - $(window).height() / 5
  }, 500);
};

InlineVariations.init = function(arg, done) {
  var buyButton, carouselViews, dealMedia, dealOptionUuid, dealUuid, deliveryEstimates, inlineVariations, isCart, isResponsive, isTouch, mappings, offer, options, preSelectTraits, ref, ref1, stickyHeader, touchBuyButton, traits;
  buyButton = arg.buyButton, deliveryEstimates = arg.deliveryEstimates, inlineVariations = arg.inlineVariations, offer = arg.offer, stickyHeader = arg.stickyHeader;
  if (!((inlineVariations != null ? (ref = inlineVariations.options) != null ? ref.length : void 0 : void 0) && ((ref1 = inlineVariations.traits) != null ? ref1.length : void 0))) {
    return done();
  }
  dealOptionUuid = inlineVariations.dealOptionUuid, dealUuid = inlineVariations.dealUuid, isResponsive = inlineVariations.isResponsive, isTouch = inlineVariations.isTouch, mappings = inlineVariations.mappings, options = inlineVariations.options, preSelectTraits = inlineVariations.preSelectTraits, traits = inlineVariations.traits;
  if (typeof DealCarousel !== "undefined" && DealCarousel !== null) {
    carouselViews = DealCarousel.carouselViews, dealMedia = DealCarousel.dealMedia;
  }
  isCart = (isTouch && (buyButton != null ? buyButton.cartIcon : void 0)) || (!isTouch && (typeof payload !== "undefined" && payload !== null ? payload.cartStatus : void 0));
  options = new InlineVariations.Collections.Options(options);
  traits = new InlineVariations.Collections.Traits(traits, {
    isTouch: isTouch
  });
  if (isTouch) {
    touchBuyButton = isResponsive ? ResponsiveBuyButton : TouchBuyButton;
    touchBuyButton.eventBus.board('buy_button_clicked', (function(_this) {
      return function() {
        if (_this.main.variationsSelected()) {
          return;
        }
        _this.main.showErrorMessages();
        _scrollToTouchInlineVariation();
        return {
          stopTheBus: true
        };
      };
    })(this))(-300);
  } else {
    BuyButton.eventBus.board('buy_button_clicked', (function(_this) {
      return function() {
        if (BuyButton.view.variationsSelected) {
          return;
        }
        _this.main.showErrorMessages();
        if (stickyHeader) {
          _scrollToBuyButton();
        }
        BuyButton.view.enableBuyButton();
        return {
          stopTheBus: true
        };
      };
    })(this));
  }
  return $((function(_this) {
    return function() {
      var ref2;
      _this.main = new InlineVariations.Views.Main({
        carouselViews: carouselViews,
        dealMedia: dealMedia,
        dealOptionUuid: dealOptionUuid,
        dealUuid: dealUuid,
        deliveryEstimates: deliveryEstimates,
        isCart: isCart,
        isTouch: isTouch,
        mappings: mappings,
        offer: offer,
        options: options,
        preSelectTraits: preSelectTraits,
        traits: traits,
        _scrollToTouchInlineVariation: _scrollToTouchInlineVariation
      });
      traits.view = _this.main;
      if (options != null ? (ref2 = options[0]) != null ? ref2.hideOriginalPriceAndDiscount : void 0 : void 0) {
        $('.deal-discount').hide();
        $('.price-and-value .discount-value').html('');
      }
      $(document.body).on('carouselUpdate', function(e, arg1) {
        var image;
        image = arg1.image;
        return _this.main.updateInlineVariationSelections(image);
      });
      return done();
    };
  })(this));
};

module.exports = InlineVariations;

//# sourceMappingURL=data:application/json;base64,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
